import { render, staticRenderFns } from "./QuickEmailBuy.vue?vue&type=template&id=2c485123&scoped=true&"
import script from "./QuickEmailBuy.vue?vue&type=script&lang=js&"
export * from "./QuickEmailBuy.vue?vue&type=script&lang=js&"
import style0 from "./QuickEmailBuy.vue?vue&type=style&index=0&id=2c485123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c485123",
  null
  
)

export default component.exports